<template>
    <div class="page td-fc" @click="showBox=true">
        <div class="title">音标课程</div>
        <div class="welcome-nav">
            <span @click="checkNav('0')" :class="['nav-item',navIndex=='0'?'active':'']">课程介绍</span>
            <span @click="checkNav('1')" :class="['nav-item',navIndex=='1'?'active':'']">试听课：英式音标的第一课</span>
        </div>
        <div class="course-window">
            <div class="item-1" v-if="navIndex==0">
                <img src="../../assets/img/soundmark_course_bg.png" alt="">
            </div>
            <div class="item-1" v-if="navIndex==1">
                <video controls width="80%">
                    <source :src="courseInfo.try_curriculum.dir" type="video/webm">
                    <source src="/media/examples/flower.mp4" type="video/mp4">
                </video>
            </div>
        </div>
        <!-- 学习弹窗 -->
        <transition name="el-fade-in" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
    import {mapGetters, mapMutations} from "vuex";
    import Lockr from 'lockr'
    import {forcedReview,soundMarkCenter,wordReviewNum} from "@/api/soundmark";
    import StudyHomeCanvas from "@/components/common/StudyHomeCanvas";

    export default {
        components: {StudyHomeCanvas},
        computed: {
            ...mapGetters(['wordStudyStage'])
        },
        data() {
            return {
                navIndex: 0,
                grammarInfo: {
                    studentId: '', //学生Id
                    reviewNum: '', //需要单词复习的个数
                }, //获取单词信息
                courseInfo:'',
            };
        },
        methods: {
            ...mapMutations(['CHANGE_WORD_STUDY_TYPE']),
            checkNav(index) {
                this.navIndex = index
            },
            //获取个人信息
            async getUserInfo() {
                let params = {
                    token: Lockr.get('token')
                }
                let voiceOption = {
                    is_play: '',
                    memory_voice: '',
                    is_countdown: '',
                }
                let result = await soundMarkCenter(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.courseInfo=result.data
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            // 动态组件回调
            callBack(data) {
                if (data.type == 'close') {
                    this.windowStatus = false;
                }
            },
        },
        created() {
            this.getUserInfo() //获取蛛网信息
        },
    }
</script>

<style scoped lang='less'>
    .page {
        height: 100%;
        padding-top: 10px;
        box-sizing: border-box;

        .title {
            display: flex;
            align-items: center;
            font-size: 18px;
            line-height: 1;
            font-weight: bold;
            padding-left: 10px;
            border-left: 3px solid #333;
        }

        .title-text {
            border: 2px solid #F5A623;
            padding: 12px 17px;
            margin: 15px;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            line-height: 19px;
        }
    }

    .course-window {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 30px;
        color: #333;
        width: 100%;
        margin: 0 auto;
        .item-1{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            video{
                width: 100%;
                height: 100%;
            }
            img{
                max-width: 100%;
            }
        }
    }

    .welcome-nav {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 116px;

        .nav-item {
            position: relative;
            font-size: 24px;
            font-weight: bold;
            margin-right: 25px;
            color: #999;
            cursor: pointer;
        }

        .active {
            color: #e54d42;
        }

        .active:before {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 10px;
            width: 100%;
            content: '';
            border-radius: 100%;
            background-color: rgba(255, 0, 0, 0.2);
            z-index: 0;
            box-shadow: 3px 3px 5px #ccc;
        }
    }

    @media (max-width: 980px) {
        .course-window {
            font-size: 24px;
        }
    }
</style>